// src/config/SeoConfig.js
export const siteConfig = {
  siteName: "Deccan Services",
  siteUrl: "https://www.deccanservices.com",
  siteLogo: "/DeccanServicesLogo.jpg",
  defaultImage: "/DeccanServicesLogo.jpg",
  address: {
    nashik: {
      street: "Flat No. 7, Building No. 2, Datar Society, Mumbai - Agra Hwy, near Tractor House, Tigraniya Corner, Dwarka",
      city: "Nashik",
      state: "Maharashtra",
      pincode: "422001",
      country: "IN"
    },
    vadodara: {
      street: "Janta Sheri Fatehgunj, Navyug High School Road",
      city: "Vadodara",
      state: "Gujarat",
      country: "IN"
    }
  },
  phones: [
    "+919766242424",
    "+919422294070"
  ],
  email: "info@deccanservices.com",
  socialMedia: {
    facebook: "https://www.facebook.com/deccan.service/",
    instagram: "https://www.instagram.com/deccan_services",
    twitter: "#",
    whatsapp: "https://wa.me/919766242424"
  },
  openingHours: "24/7",
  founded: "2010",
  rating: {
    value: "4.8",
    count: "14500"
  }
};

export const defaultSEO = {
  title: "Deccan Services - Apna Service Partner | Appliance Repair in Nashik",
  description: "Your trusted appliance repair partner in Nashik since 2010. Expert AC repair, washing machine repair, refrigerator repair & microwave oven repair. Same-day service, 90-day warranty, certified technicians.",
  keywords: "appliance repair Nashik, AC repair Nashik, washing machine repair Nashik, refrigerator repair Nashik, microwave oven repair Nashik, home appliance repair, Deccan Services",
  author: "Deccan Services",
  robots: "index, follow",
  language: "English",
  revisitAfter: "7 days",
  image: "/DeccanServicesLogo.jpg"
};

// Service-specific SEO configurations
export const serviceSEO = {
  "ac-repair": {
    title: "Professional AC Repair Services in Nashik | Deccan Services",
    description: "Expert AC repair in Nashik by certified technicians. Same-day service for split AC, window AC & central AC. Genuine parts, 90-day warranty, competitive pricing. Book now!",
    keywords: "AC repair Nashik, AC service Nashik, air conditioner repair, split AC repair, window AC service, central AC maintenance, AC gas refilling Nashik, AC not cooling repair",
    heading: "Expert AC Repair & Maintenance",
    subheading: "Professional repair and maintenance for all types of air conditioners",
    image: "/images/services/ac-repair.jpg",
    canonical: "/services/ac-repair"
  },
  "washing-machine-repair": {
    title: "Washing Machine Repair Service in Nashik | Deccan Services",
    description: "Expert washing machine repair in Nashik. Same-day service for top load, front load & semi-automatic machines. All brands serviced. Genuine parts, 90-day warranty.",
    keywords: "washing machine repair Nashik, washing machine service, top load repair, front load repair, washing machine technician, washer repair Nashik, automatic washing machine repair",
    heading: "Professional Washing Machine Repair",
    subheading: "Expert repair for all types of washing machines",
    image: "/images/services/washing-machine.jpg",
    canonical: "/services/washing-machine-repair"
  },
  "refrigerator-repair": {
    title: "Refrigerator Repair Service in Nashik | Deccan Services",
    description: "Expert refrigerator repair in Nashik. Same-day service for all brands. Fix cooling issues, gas refilling, compressor repair. 90-day warranty on all repairs.",
    keywords: "refrigerator repair Nashik, fridge repair, refrigerator service, cooling problem solution, fridge gas refilling, compressor repair, double door fridge repair",
    heading: "Expert Refrigerator Repairs",
    subheading: "Fast Cooling Solutions You Can Trust!",
    image: "/images/services/refrigerator.jpg",
    canonical: "/services/refrigerator-repair"
  },
  "microwave-oven-repair": {
    title: "Microwave Oven Repair in Nashik | Deccan Services",
    description: "Expert microwave oven repair in Nashik. Same-day service for all brands. Fix heating issues, sparking, turntable problems. 90-day warranty, certified technicians.",
    keywords: "microwave oven repair Nashik, microwave repair, oven service, convection microwave repair, grill microwave repair, microwave not heating repair",
    heading: "Microwave Oven Repair Services",
    subheading: "Expert repair for all microwave oven brands",
    image: "/images/services/microwave.jpg",
    canonical: "/services/microwave-oven-repair"
  }
};

// Page-specific SEO configurations
export const pageSEO = {
  "/": {
    title: "Deccan Services - Apna Service Partner | Home Appliance Repair Nashik",
    description: "Deccan Services - Your trusted appliance repair partner in Nashik since 2010. Expert AC, washing machine, refrigerator & microwave repair. Same-day service, 90-day warranty.",
    keywords: "Deccan Services, appliance repair Nashik, home appliance repair, AC repair, washing machine repair, refrigerator repair, microwave repair",
    canonical: "/"
  },
  "/about": {
    title: "About Deccan Services | Trusted Appliance Repair Partner Since 2010",
    description: "Learn about Deccan Services - your trusted appliance repair partner in Nashik since 2010. Quality service, certified technicians, 90-day warranty, and customer satisfaction guaranteed.",
    keywords: "about Deccan Services, appliance repair company Nashik, certified technicians, service warranty, customer satisfaction",
    canonical: "/about"
  },
  "/services": {
    title: "Our Services | AC, Washing Machine, Refrigerator & Microwave Repair",
    description: "Comprehensive appliance repair services in Nashik. AC repair, washing machine repair, refrigerator repair, microwave oven repair. Certified technicians, same-day service.",
    keywords: "appliance repair services, AC repair service, washing machine repair service, refrigerator repair service, microwave repair service, home appliance repair",
    canonical: "/services"
  },
  "/whychooseus": {
    title: "Why Choose Deccan Services | Expert Technicians, 90-Day Warranty",
    description: "Discover why customers choose Deccan Services. Expert certified technicians, quick & reliable service, affordable pricing, genuine spare parts, 90-day warranty, 24/7 emergency service.",
    keywords: "why choose Deccan Services, certified technicians Nashik, appliance repair warranty, reliable service, affordable repair, genuine parts",
    canonical: "/whychooseus"
  },
  "/contactus": {
    title: "Contact Deccan Services | Appliance Repair Nashik - 24/7 Support",
    description: "Contact Deccan Services for all your appliance repair needs. Multiple locations in Nashik and Vadodara. Call +91 9766242424 or email info@deccanservices.com. 24/7 emergency service.",
    keywords: "contact Deccan Services, appliance repair contact, Nashik repair service, Vadodara repair service, emergency repair, customer support",
    canonical: "/contactus"
  }
};